import React from 'react';

const PaginationContext = React.createContext();

export default PaginationContext;